export interface ProblemDetails {
  title?: string
  detail?: string
  status?: number
}

export class ApiError extends Error {
  constructor(readonly status: number, readonly problem: ProblemDetails) {
    super(problem.title ?? `API error ${status}`)
    this.name = 'ApiError'
  }
}
